module.exports = __webpack_public_path__ + "static/media/features-split-image-03.5c565c8d.svg";